'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Memoize = Memoize;

var _lodash = require('lodash');

var _DecorateInstance = require('./DecorateInstance');

/**
 * @param {function} [resolver]
 */
function Memoize(resolver) {

  return (0, _DecorateInstance.DecorateInstance)(_lodash.memoize, resolver);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9NZW1vaXplLmpzIl0sIm5hbWVzIjpbIk1lbW9pemUiLCJyZXNvbHZlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFNZ0JBLE8sR0FBQUEsTzs7QUFOaEI7O0FBQ0E7O0FBRUE7OztBQUdPLFNBQVNBLE9BQVQsQ0FBaUJDLFFBQWpCLEVBQTJCOztBQUU5QixTQUFPLHlEQUEwQkEsUUFBMUIsQ0FBUDtBQUVIIiwiZmlsZSI6Ik1lbW9pemUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge21lbW9pemV9IGZyb20gJ2xvZGFzaCc7XG5pbXBvcnQge0RlY29yYXRlSW5zdGFuY2V9IGZyb20gJy4vRGVjb3JhdGVJbnN0YW5jZSc7XG5cbi8qKlxuICogQHBhcmFtIHtmdW5jdGlvbn0gW3Jlc29sdmVyXVxuICovXG5leHBvcnQgZnVuY3Rpb24gTWVtb2l6ZShyZXNvbHZlcikge1xuXG4gICAgcmV0dXJuIERlY29yYXRlSW5zdGFuY2UobWVtb2l6ZSwgcmVzb2x2ZXIpO1xuXG59XG4iXX0=